
import RequestAbstract from "../abstract";

export default class Messages extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/messaging/messages";
    }

}

